

/**
 * 将中文key 转为 英文key
 */
export const transKeyName = (arr = [], keyMapping = {}) => {
  // if(arr.length <= 0 || keyMapping == {}) { return '' };
  const cnKey = Object.keys(arr[0]);
  
  return arr.map(item => {
    const obj = {};
    cnKey.forEach(key => {
      const enKey = keyMapping[key];
      if(enKey){
        obj[enKey] = item[key];
      }
    })
    return obj;
  })
}

export const formatDate = (timestamp, type) => {
  let date = new Date(timestamp);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let seconds = date.getSeconds();
  if (!type) {
    return year + "-" + addZero(month) + "-" + addZero(day) + " " + addZero(hours) + ":" + addZero(minutes) + ":" + addZero(seconds);
  } else if (type == 'yyyyMMdd') {
    return year + '' + addZero(month) + '' + addZero(day);
  } else if (type == 'yyyy-MM-dd') {
    return year + '-' + addZero(month) + '-' + addZero(day);
  }
}

function addZero(num) {
  return num < 10 ? "0" + num : num;
}

// 不足位数前补 0
export function prefixInteger(num, length) {
  return (Array(length).join('0') + num).slice(-length);
}

/**
 * 对数组进行分类
 * @param {Object} array   数组
 * @param {Object} property      要分类的属性名
 */
export function groupBy(array, property) {
  return array.reduce(function(prev, obj) {
    let key = obj[property];
    if (!prev[key]) {
      prev[key] = [];
    }
    prev[key].push(obj);
    return prev;
  }, {})
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}
